import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  for (const key of locales.keys()) {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = {
        ...locales(key)
      }
    }
  }
  return messages
}

const messages = loadLocaleMessages()

Vue.prototype.$languages = Object.keys(messages).map(langlage => ({
  label: messages[langlage]._name,
  value: langlage
}))

let cur_lang = navigator.language || navigator.browserLanguage || ''
if (cur_lang === 'zh-cn') cur_lang = 'zh-CN'

const i18n = new VueI18n({
  locale: cur_lang,
  fallbackLocale: 'en-US',
  messages,
  silentTranslationWarn: true
})

export default i18n
